module.exports = __webpack_public_path__ + "static/media/SM-ST-O2-wrong.9e73b886.mp3";